import { useEffect, useRef, useState } from "react";
import { defer, type Observable, Subject, takeUntil } from "rxjs";

export function useObservableFn<T extends (...args: any[]) => Observable<any>>(
  fn: T,
  options?: {
    enabled?: boolean;
  }
) {
  const { enabled = true } = options ?? {};

  const unmountedRef = useRef(false);
  const [unmounted$] = useState(() => new Subject<void>());
  useEffect(() => {
    unmountedRef.current = false;
    return () => {
      unmountedRef.current = true;
      unmounted$.next();
    };
  }, []);

  useEffect(() => {
    if (!enabled) {
      unmounted$.next();
    }
  }, [enabled]);

  return (...args: any[]) => {
    return defer(() => {
      if (!enabled || unmountedRef.current) {
        throw new Error("unmounted");
      }

      const ob = fn(...args);

      return ob.pipe(takeUntil(unmounted$));
    });
  };
}
